import script from "./ConfigAsistencia.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigAsistencia.vue?vue&type=script&setup=true&lang=js"

import "./ConfigAsistencia.vue?vue&type=style&index=0&id=0c1bcb2a&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c1bcb2a"]])

export default __exports__